import { t } from '@lingui/macro';
import { Card, CardContent, CardHeader } from '@pocketlaw/tetris';
import { ReviewFeedbackType } from 'shared/domains/apollo/generated/types';
import { objectEntries } from 'shared/domains/common-utils';
import { Legend } from './Legend';
import { ProgressBar } from './ProgressBar';
import { countBy, getAppearance, getIcon, getLabel, progressTypeMap, compareProgress, } from './utils';
import { usePlai } from '../PlaiProvider';
export function ReviewProgress() {
    const { review } = usePlai();
    const { feedbacks = [] } = review || {};
    if (feedbacks.length < 1) {
        return null;
    }
    const total = feedbacks.length;
    const feedbackCounts = countBy(feedbacks, feedback => feedback.feedback.type === ReviewFeedbackType.Approved
        ? progressTypeMap[ReviewFeedbackType.Approved]
        : progressTypeMap[feedback.feedback.criticality]);
    const progress = objectEntries(feedbackCounts)
        .sort(([a], [b]) => compareProgress(a, b))
        .map(([type, value]) => ({
        appearance: getAppearance(type),
        label: getLabel({ value, type }),
        icon: getIcon(type),
        value: Math.round((100 * value) / total),
    }));
    const currentProgressValue = feedbackCounts.approved || 0;
    return (<Card>
      <CardHeader title={t({
            message: 'Review status',
            comment: 'Plai review progress status - title',
        })}/>
      <CardContent>
        <ProgressBar progress={progress} currentValue={currentProgressValue}/>
        <Legend progress={progress}/>
      </CardContent>
    </Card>);
}
